import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets window scroll to top whenever the route pathname changes.
// Skips when there's a hash (so anchor links like #roadmap still work).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
